'use client';

import { Card, CardContent, CardHeader } from '@packages/shared/src/ui/Card/Card';
import { useIntl } from 'react-intl';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { LegalHintsCardFragmentFragmentDoc } from '@packages/gql/generated/shopping/LegalHintsCardFragmentFragmentDoc';
import { legalHintsCardMessages } from './messages';
import { LegalHintsItem } from '../LegalHintsItem';

/*
 * INFO: As of right now the data structure for productHints and legalHints is the same, so the components are mostly identical.
 * The data for these two might change in the future and then the two components would have to be split again. For this reason we decided to split into seperate cards them from the start.
 */

/* GraphQL */ `
  fragment LegalHintsCardFragment on Product {
    legalHints {
      ...LegalHintsItemFragment
    }
  }
`;

export type LegalHintsCardProps = {
  legalHintsData: FragmentType<typeof LegalHintsCardFragmentFragmentDoc>;
};

/**
 * LegalHintsCard component displays all available legal hints
 * */
export const LegalHintsCard = ({ legalHintsData }: LegalHintsCardProps) => {
  const { legalHints } = getFragmentData(LegalHintsCardFragmentFragmentDoc, legalHintsData);

  const { formatMessage } = useIntl();

  if (legalHints.length === 0) return null;

  return (
    <Card>
      <CardHeader hasDivider>
        {formatMessage(legalHintsCardMessages.legalHintsCardHeader)}
      </CardHeader>
      <CardContent className="py-2">
        <ul className="space-y-2">
          {legalHints.map((legalHint, idx) => (
            // eslint-disable-next-line react/no-array-index-key
            <li key={idx}>
              <LegalHintsItem legalHintsData={legalHint} />
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
};
